var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.$style.button},[_c('i',{staticClass:"fa fa-star",class:( _obj = {}, _obj[_vm.$style.favorited] = _vm.favorited, _obj ),attrs:{"title":_vm.favorited ? 'Unfavorite' : 'Favorite'},on:{"click":function($event){$event.stopPropagation();return _vm.$emit('toggle')}}})])}
var staticRenderFns = []

export { render, staticRenderFns }